// Spaltenordnung der Lead-Listen (Smart Views, Leads), rein und ohne React (mit node --test prüfbar):
// Name zuerst, direkt daneben der Status, dann eine schmale Spalte mit Telefon- und Mail-Symbol, danach die übrigen
// Spalten der View. Telefon und E-Mail stehen nicht mehr als eigene Textspalten da (Dilsar, 14.10.2026).

export interface SpaltenKopf {
  key: string;
  label: string;
}

/** Schlüssel der Symbolspalte (Telefon und E-Mail des Hauptkontakts). */
export const KONTAKTWEGE = "kontaktwege";

const NAME = new Set(["display_name", "name"]);
const STATUS = new Set(["status_id", "status_label"]);

export function istNameSpalte(key: string): boolean {
  return NAME.has(key);
}

export function istStatusSpalte(key: string): boolean {
  return STATUS.has(key);
}

/** Telefon/E-Mail-Spalten aus Close (primary_phone, primary_email, „Email & Phone“ …), keine Custom Fields. */
export function istKontaktwegSpalte(key: string): boolean {
  if (key === KONTAKTWEGE) return true;
  if (key.startsWith("custom.") || key.startsWith("cf_")) return false;
  return /(^|[_.])(phone|phones|email|emails)([_.]|$)/i.test(key);
}

export function listenSpalten<T extends SpaltenKopf>(roh: T[], neu: (s: SpaltenKopf) => T = (s) => s as T): T[] {
  const name = roh.find((s) => istNameSpalte(s.key)) ?? neu({ key: "display_name", label: "Name" });
  const status = roh.find((s) => istStatusSpalte(s.key)) ?? neu({ key: "status_id", label: "Status" });
  const rest = roh.filter((s) => !istNameSpalte(s.key) && !istStatusSpalte(s.key) && !istKontaktwegSpalte(s.key));
  return [name, status, neu({ key: KONTAKTWEGE, label: "" }), ...rest];
}
